import React from "react";
import Dialog from "material-ui/Dialog";

const titleStyle = {
    width: "100%",
    height: "19px",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
    textAlign: "left",
    margin: "10px",
    color: "#ffffff"
};
export default class NewCustomDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: ""
        };
    }

    _getTitleContent(title) {
        return (
            <div
                style={{
                    padding: "16px 25px",
                    lineHeight: "normal",
                    fontSize: "16px",
                    marginBottom: "0px",
                    backgroundColor: "#334969",
                    borderRadius: "3px"
                }}
                className="confirm_dialog_header"
            >
                <span style={titleStyle}>{title}</span>
                <span style={{ float: "right", cursor: "pointer" }}>
                    <i
                        className="material-icons"
                        style={{ fontSize: "21px" }}
                        onClick={this._closeDialog.bind(this)}
                    >
                        clear
                    </i>
                </span>
                {this.props.autoScrollBodyContent ? (
                    ""
                ) : (
                    <hr style={{ margin: "0px -13px 0px -13px" }} />
                )}
            </div>
        );
    }

    _closeDialog() {
        this.props.onRequestClose();
    }

    render() {
        //console.log('props',this.props,this.props.autoScrollBodyContent)
        return (
            <Dialog
                {...this.props}
                title={this._getTitleContent(this.props.title)}
                bodyStyle={{
                    fontSize: "13px",
                    fontFamily: "Roboto-Regular",
                    color: "#16325c",
                    padding: "10px 10px 10px 10px"
                }}
                //titleStyle={{margin:'0px 0px 0px 0px'}}
            />
        );
    }
}
